module.exports = __webpack_public_path__ + "static/media/modalEdit.0f981980.svg";